import React from 'react';
import moment from 'moment';
import { camelize } from 'humps';
import { isUrl } from './isUrl';
import { URLCell } from '../components/molecules/URLCell';

const formatCell = (params, hints) => {
  const {
    value,
    colDef: { field }
  } = params;

  if (value === null) return '';

  const hint = hints?.[camelize(field)];

  switch (hint) {
    case 'percentage needs multiplication':
      if (Number.isNaN(value)) return value;
      return `${Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
      }).format(value * 100)}%`;

    case 'percentage no multiplication':
      if (Number.isNaN(value)) return value;
      return `${Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2,
        minimumFractionDigits: 0
      }).format(value)}%`;

    case 'date': {
      const m = moment.utc(value);
      if (!m.isValid()) return value;
      return m.format('MM/DD/YYYY');
    }

    case 'currency':
      if ((typeof value === 'string' || value instanceof String) && value.startsWith('$')) {
        return Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 2
        }).format(value.replace('$', ''));
      }

      if (Number.isNaN(Number(value))) {
        return value;
      }

      return Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2
      }).format(value);

    case 'number':
      return value;
    case 'count':
      if (Number.isFinite(value)) {
        const hasDecimals = value % 1 !== 0;
        return Intl.NumberFormat('en-US', {
          maximumFractionDigits: hasDecimals ? 2 : 0,
          minimumFractionDigits: hasDecimals ? 2 : 0
        }).format(value);
      }
      return value;

    default:
      if (typeof value === 'string' && isUrl(value)) {
        return <URLCell url={value} />;
      }
      return value === '' ? 'Null' : value?.toString();
  }
};

export { formatCell };
